import { useCallback } from "react";

import ACL_RELATIONSHIPS from "acl-relationships";
import { getNextQueryParams } from "components/helpers";
import withRoleCheck from "components/hocs/withRoleCheck";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import FormDialog from "components/modals/FormDialog";
import RecipientService from "services/Recipient";
import RecipientForm from "routes/recipients/RecipientForm";
import {
  invalidateRecipientsQuery,
  useRecipientsTable,
} from "hooks/useRecipientsTable";

export const RECIPIENTS_TABLE_CONSTANTS = {
  tableName: "Recipients",
  queryKey: "recipients",
  className: "Recipients",
  exportTableName: null,
  header: "Recipients",
  headerIcon: "shop",
};

const CreateRecipientModal = withRoleCheck(FormDialog, [
  ACL_RELATIONSHIPS.recipient.create,
]);

const RecipientsTableV3 = () => {
  const { columns, filters } = useRecipientsTable();

  const fetchRecipients = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);

        const response = await RecipientService.getTable(nextQueryParams);

        return response;
      } catch (error) {
        console.error("Error fetching recipients:", error);
        throw error;
      }
    },
    [columns]
  );

  return (
    <BaseTableV3
      columns={columns}
      headerIcon={RECIPIENTS_TABLE_CONSTANTS.headerIcon}
      header={RECIPIENTS_TABLE_CONSTANTS.header}
      queryKey={RECIPIENTS_TABLE_CONSTANTS.queryKey}
      className={RECIPIENTS_TABLE_CONSTANTS.className}
      tableName={RECIPIENTS_TABLE_CONSTANTS.tableName}
      createButton={
        <CreateRecipientModal
          onSuccess={invalidateRecipientsQuery}
          modelType="Recipient"
          FormComponent={RecipientForm}
        />
      }
      fetchData={fetchRecipients}
      invalidateData={invalidateRecipientsQuery}
      filters={filters}
      enableSearch
      enableSettings
    />
  );
};

export default RecipientsTableV3;
